import { Component, OnInit } from '@angular/core';
import { service_methods6 } from '../admin/service_methods6';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  arr_profile = [];
  constructor(private obj: service_methods6) { }

  ngOnInit() {
    this.getUserProfile();
  }
  getUserProfile(){
    this.arr_profile = [];
    this.obj._commonget("user_profile_get").then(data =>{
      this.arr_profile = data;
    })
  }
}
